import { datadogRum } from '@datadog/browser-rum';

/**
 * Reported at most once per browser session so a systemic outage (every retry
 * timing out) can't spam RUM.
 */
export const PREVIEW_GENERATION_ERROR_DEDUPE_KEY = 'pod:preview-generation-error-reported';

export const reportPreviewGenerationErrorOnce = (
  dedupeKey: string,
  error: Error,
  meta: Record<string, unknown> = {},
): void => {
  try {
    if (window.sessionStorage.getItem(dedupeKey)) {
      return;
    }
    window.sessionStorage.setItem(dedupeKey, '1');
  } catch {
    // sessionStorage can throw in private modes / disabled storage; still report.
  }
  datadogRum.addError(error, { source: 'preview-generation', ...meta });
};
